import { Routes } from "@angular/router";

/**
 * reference all our lazy-loaded tray modules here.
 */
export const trays: Routes = [
    {
        path: "menu-tray",
        loadChildren: () =>
            import("@hermes/hermes-web-trays-menu-tray").then(
                (m) => m.MenuTrayStateModule,
            ),
    },
    {
        path: "size-guide-tray",
        loadChildren: () =>
            import("@hermes/domains-size-guide-trays-size-guide-tray").then(
                (m) => m.SizeGuideTrayStateModule,
            ),
    },
    {
        path: "country-selector-tray",
        loadChildren: () =>
            import("@hermes/hermes-web-trays-country-selector-tray").then(
                (m) => m.CountrySelectorTrayModule,
            ),
    },
    {
        path: "ereservation-tray",
        loadChildren: () =>
            import("@hermes/domains-e-resa-trays-ereservation-tray").then(
                (m) => m.EreservationTrayStateModule,
            ),
    },
    {
        path: "shop-locations-countries-tray",
        loadChildren: () =>
            import("@hermes/domains-shop-trays-shop-locations-countries-tray").then(
                (m) => m.ShopLocationsCountriesTrayModule,
            ),
    },
    {
        path: "shop-locations-cities-tray",
        loadChildren: () =>
            import("@hermes/domains-shop-trays-shop-locations-cities-tray").then(
                (m) => m.ShopLocationsCitiesTrayModule,
            ),
    },
    {
        path: "back-in-stock-tray",
        loadChildren: () =>
            import("@hermes/domains-back-in-stock-trays-back-in-stock-tray").then(
                (m) => m.BackInStockTrayModule,
            ),
    },
    {
        path: "live-shopping-tray",
        loadChildren: () =>
            import("@hermes/domains-live-shopping-trays-live-shopping-tray").then(
                (m) => m.LiveShoppingTrayModule,
            ),
    },
    {
        path: "product-locator-tray",
        loadChildren: () =>
            import("@hermes/domains-e-resa-trays-product-locator-tray").then(
                (m) => m.ProductLocatorTrayStateModule,
            ),
    },
    {
        path: "grid-filters-tray",
        loadChildren: () =>
            import("@hermes/hermes-web-trays-grid-filters-tray").then(
                (m) => m.GridFiltersTrayModule,
            ),
    },
    {
        path: "register-your-interest-tray",
        loadChildren: () =>
            import(
                "@hermes/domains-register-your-interest-trays-register-your-interest-tray"
            ).then((m) => m.RegisterYourInterestTrayModule),
    },
    {
        path: "newsletter-subscribe-tray",
        loadChildren: () =>
            import("@hermes/domains-customer-trays-newsletter-subscribe-tray").then(
                (m) => m.NewsletterSubscribeModule,
            ),
    },
    {
        path: "geofiltering-tray",
        loadChildren: () =>
            import("@hermes/domains-shell-trays-geofiltering-tray").then(
                (m) => m.GeoFilteringTrayModule,
            ),
    },
];
